module.exports = __webpack_public_path__ + "static/book_cover-2ada59625fb39dcc4b1cfbd2c8c38d05.png";